import PopUpCloseIcon from "common/svg/PopUpCloseIcon";
import { MouseEventHandler } from "react";
import IconButton from "../styled-components/IconButton";
import PopUp from "./styled-components/PopUp";
import PopUpContainer from "./styled-components/PopUpContainer";
import PopUpTitle from "./styled-components/PopUpTitle";
import PopUpTitleContainer from "./styled-components/PopUpTitleContainer";

interface TooltipPopUpProps {
  title: string;
  handleClose: MouseEventHandler<HTMLButtonElement>;
  children: React.ReactNode;
}

function TooltipPopUp({ title, handleClose, children }: TooltipPopUpProps) {
  return (
    <PopUpContainer>
      <PopUp>
        <PopUpTitleContainer>
          <PopUpTitle>{title}</PopUpTitle>
          <IconButton onClick={handleClose}>
            <PopUpCloseIcon />
          </IconButton>
        </PopUpTitleContainer>
        {children}
      </PopUp>
    </PopUpContainer>
  );
}

export default TooltipPopUp;
